
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import SystemMessageOverview from '@/views/communication/events/SystemMessageOverview.vue'
import { SystemMessageData, SystemMessageTrigger } from '@/types/systemMessage'
import axios from 'axios'

@Component({
  components: { SystemMessageOverview }
})
export default class SystemMessageTriggerModal extends Vue {
  @Prop({ default: false, required: true }) visible!: boolean
  @Prop({ default: null, required: false, type: SystemMessageTrigger }) trigger!: SystemMessageTrigger
  @Prop({ default: Array }) messages!: SystemMessageData[]
  @Prop({ default: Array }) types!: string[]
  @Prop({ default: Array }) targets!: string[]

  @Watch('visible')
  onVisibleChange (visible: boolean): void {
    this.modalVisible = visible
    if (visible) {
      this.eventData = this.trigger || new SystemMessageTrigger()
    }
  }

  eventData: SystemMessageTrigger = new SystemMessageTrigger()
  modalVisible = false

  get isVisible (): boolean {
    return this.visible && this.modalVisible
  }

  get isUpdate (): boolean {
    return this.trigger.id !== null
  }

  get title (): string {
    return `Trigger ${this.isUpdate ? 'bijwerken' : 'toevoegen'}`
  }

  get canEdit (): boolean {
    return true
  }

  get canSave (): boolean {
    if (this.isAutoManaged) {
      return false
    }

    return this.eventData.description !== '' &&
        this.eventData.name !== ''
  }

  get isAutoManaged (): boolean {
    return this.eventData.source_key !== null
  }

  save (): void {
    const payload = this.getPayload()
    axios.post(process.env.VUE_APP_API_URL + '/system-message-triggers', payload)
      .then(() => {
        this.resetModal(true)
      })
  }

  update (): void {
    const payload = this.getPayload()
    axios.put(process.env.VUE_APP_API_URL + '/system-message-triggers/' + this.trigger.id, payload)
      .then(() => {
        this.resetModal(true)
      })
  }

  getPayload (): { name: string, description: string } {
    return {
      name: this.eventData.name,
      description: this.eventData.description
    }
  }

  resetModal (changed: boolean): void {
    this.eventData = new SystemMessageTrigger()
    this.$emit('closed', changed)
  }
}
